import { Box, ChakraProvider, Grid, VStack } from '@chakra-ui/react';
import { StateMachineProvider } from 'little-state-machine';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from 'react-query';

import ClickGuard from '../components/ClickGuard';
import engeneTheme from '../constants/theme';
import { GlobalStoreInitializer } from '../GlobalStore';
// import { ColorModeSwitcher } from '../../ColorModeSwitcher';
import AppRouter from '../routes';
import { ColorProvider } from './ColorProvider';
import ErrorFallback from './error-boundary/ErrorFallback';
import { SizeProvider } from './SizeProvider';

// Initializing global store.
GlobalStoreInitializer.createGlobalStore();

// React Query: create Query Client.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 300000,
    },
  },
});

const App = () => (
  <ChakraProvider theme={engeneTheme}>
    <SizeProvider>
      <ColorProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <StateMachineProvider>
            <QueryClientProvider client={queryClient}>
              <ClickGuard />
              <Box textAlign="center" fontSize="xl">
                <Grid minHeight="100vh" maxWidth="100vw" padding={3}>
                  {/* <ColorModeSwitcher justifySelf="flex-end" /> */}
                  <VStack spacing={8}>
                    <AppRouter />
                  </VStack>
                </Grid>
              </Box>
            </QueryClientProvider>
          </StateMachineProvider>
        </ErrorBoundary>
      </ColorProvider>
    </SizeProvider>
  </ChakraProvider>
);
export default App;
